module.exports = __webpack_public_path__ + "img/enlightenment-course-2.e6026cc7.png";